// extracted by mini-css-extract-plugin
module.exports = {"footer-container":"PaymentFooter_footer-container__8NRly","footer-content":"PaymentFooter_footer-content__y5aO_","footer-text":"PaymentFooter_footer-text__dnFiq"};